// Shared eight-tab customer navigation from the approved October 12 stack.
import { useLocation, useNavigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { getReviewReturnTarget } from './ReviewState.js';

export type CustomerTabKey =
  | 'current' | 'build-order' | 'subscription' | 'colic-coverage'
  | 'gifts' | 'horses' | 'relationships' | 'history' | 'service-needs';

const TABS: Array<{ key: CustomerTabKey; label: string; path: string }> = [
  { key: 'current', label: 'Current action', path: 'current-action' },
  { key: 'build-order', label: 'Build an order', path: 'build-order' },
  { key: 'subscription', label: 'Subscription', path: 'subscriptions' },
  { key: 'colic-coverage', label: 'Colic Coverage', path: 'colic-coverage' },
  { key: 'gifts', label: 'Gifts', path: 'gifts' },
  { key: 'horses', label: 'Horses', path: 'horses' },
  { key: 'relationships', label: 'Relationships', path: 'relationships' },
  { key: 'history', label: 'History', path: 'history' },
];

export interface CustomerTabsProps {
  customerId: string;
  active: CustomerTabKey;
  // Retained for old callers; the current approved bar always has eight tabs.
  includeServiceNeeds?: boolean;
}

export function CustomerTabs({ customerId, active }: CustomerTabsProps): ReactNode {
  const navigate = useNavigate();
  const location = useLocation();
  return <nav data-component="customer-tabs" className="tabs" aria-label="Customer views">
    {TABS.map((tab) => <button key={tab.key} type="button"
      aria-current={tab.key === active ? 'page' : undefined}
      onClick={() => {
        const target = getReviewReturnTarget(location.state, customerId, location.pathname + location.search);
        navigate('/' + tab.path + '/' + encodeURIComponent(customerId), {
          state: target.state,
        });
      }}>{tab.label}</button>)}
  </nav>;
}
